import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Convocacao } from '../models/convocacao.model';
import { Observable } from 'rxjs/Observable';
import { ResultGetPaged } from 'pmv-common';
import { ConvocacaoFilter } from '../models/convocacao-filter';
import { DadosAcumuloCargo } from '../models/dadosAcumuloCargo.model';
import { DTO } from '../models/dto/dto';

@Injectable()
export class ConvocacaoService {
  postConsultaDeclaracaoAcumuloCargoPreenchida(dados: DadosAcumuloCargo): Observable<DTO> {
    return this.httpClient.post<DTO>(`Convocacao/PostDadosAcumuloCargoPreenchida/`, dados);
  }
  constructor(private httpClient: HttpClient) { }

  TratarErro(listaErros: Object): string[] {
    var lista = Object.keys(listaErros).map((key) => [listaErros[key]]);
    var resultado: string[] = [];
    lista.forEach(element => {
      element.forEach(itemErro => {
        itemErro.forEach(erro => {
          resultado.push(erro);
        });
      });
    });
    return resultado;
  }

  Create(convocacao: Convocacao): Observable<Convocacao> {
    return this.httpClient.post<Convocacao>(`Convocacao/PostConvocacao/`, convocacao);
  }

  GetConvocacoes(page?: number, itemsPerPage?: number, filter?: ConvocacaoFilter): Observable<ResultGetPaged<Convocacao>> {
    filter.pg = page;
    filter.itensPg = itemsPerPage;
    return this.httpClient.post<ResultGetPaged<Convocacao>>('/Convocacao/GetConvocacoes', filter);
  }

  Delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`/Convocacao/DeleteConvocacoes/${id}`);
  }

  homologar(id: number): Observable<void> {
    return this.httpClient.post<void>(`/Convocacao/PostHomologacao`, id);
  }

  postDadosAcumuloCargo(dados: DadosAcumuloCargo): Observable<DTO> {
    return this.httpClient.post<DTO>('/convocacao/PostAcumuloCargo', dados);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/convocacao.service.ts